import { render, staticRenderFns } from "./JobBook.vue?vue&type=template&id=5654f2c7&scoped=true&"
import script from "./JobBook.vue?vue&type=script&lang=js&"
export * from "./JobBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5654f2c7",
  null
  
)

export default component.exports